import React from 'react';
import * as Sentry from '@sentry/browser';

export default function useSentryScope(key, value) {
    React.useEffect(() => {
        Sentry.configureScope(scope => {
            scope.setExtra(key, value);
        });
    }, [value, key]);
}